import { SelectChangeEvent, Stack } from "@mui/material"
import { Button, DialogHandler, Dropdown, GenericWrapperContext, UserModel } from "@cakemail-org/ui-components-v2"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"
import { t } from "i18next"
import { Dispatch, MouseEvent, SetStateAction, useContext, useState } from "react"
import { getLanguagesOptions } from "../../../data/language"


function ChangeLanguageDialogContent({ setUser, resolve, reject }: { setUser: Dispatch<SetStateAction<UserModel | undefined>>, resolve: (value: unknown) => void, reject: (reason?: any) => void }) {
    const { account, user, partnerBrand } = useContext(GenericWrapperContext)
    const [language, setLanguage] = useState<string>(user.language)

    function handleLanguageChange(event: SelectChangeEvent<string>) {
        setLanguage(event.target.value)
    }

    function handleSave(event: MouseEvent<HTMLButtonElement>, btnRef?: TButtonRef) {
        btnRef?.animate()
        user.language = language
        user.update({ language: language }).then((newUser) => {
            setUser && setUser(newUser)
            DialogHandler.hide()
            resolve(newUser)
        }).catch((error) => {
            btnRef?.reset()
            DialogHandler.show({
                isExpress: true,
                type: "error",
                title: t("general-error-action"),
            })
            reject(error)
        })
    }

    return <Stack direction="column" gap={8} marginTop={8}>
        <Dropdown
            chevronIconOverride="Globe24"
            options={getLanguagesOptions({ partnerBrand })}
            onChange={handleLanguageChange}
            defaultValue={user.language}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" className="dialogBtns">
            <Button
                variant="outlined"
                color="body1"
                onClick={() => {
                    DialogHandler.hide()
                }}
            >
                {t("general-cancel")}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                animated
                onClick={(e, btnRef) => {
                    handleSave(e, btnRef)
                }}
            >
                {t("general-save")}
            </Button>

        </Stack>
    </Stack>
}


export async function showChangeLanguageDialog(setUser: Dispatch<SetStateAction<UserModel | undefined>>) {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            managedByContent: true,
            title: t("general-change-language"),
            content: (
                <ChangeLanguageDialogContent setUser={setUser} resolve={resolve} reject={reject} />
            ),
        })
    })
}